"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8179],{

/***/ 48179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_OurTechStack; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/OurTechStack/ourTechStack.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 3rem;\n    padding-right: 3rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 6.5rem;\n    padding-right: 6.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 7.5rem;\n    padding-right: 7.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    margin: 5rem 0 2rem 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    margin: 5rem 0 2.5rem 0;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    column-gap: 1.5rem;\n    row-gap: 1.5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    column-gap: 2.125rem;\n    row-gap: 2.125rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(4, 4.2rem);\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: unset;\n    margin: 4.575rem 0 5.575rem 0;\n    column-gap: 1.9rem;\n    row-gap: 1.9rem;\n    grid-template-columns: repeat(4, 5.5rem);\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    column-gap: 3.438rem;\n    row-gap: 1.875rem;\n    grid-template-columns: repeat(4, 6.5rem);\n    margin: 6rem 0 7.5rem 0;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 4.2rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 5.668rem;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 7.5rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 3.5rem;\n    padding-bottom: 7.5rem;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    justify-content: space-between;\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:not(:first-child) {\n      margin-top: 0;\n    }\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "ehsgszc0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc1"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-direction:row;justify-content:space-between;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "ehsgszc2"
})(Typography/* Headline1 */.iH, ";font-size:2rem;letter-spacing:-0.013rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:4rem 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const DescriptionText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "ehsgszc3"
})(Typography/* ParagraphS */.fw, ";letter-spacing:0.013rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";max-width:29.375rem;padding:0;margin:0;");
const IconsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc4"
})("display:grid;column-gap:1.125rem;row-gap:1.125rem;grid-template-columns:repeat(4,3.2rem);margin:4.125rem 0 5rem 0;justify-content:center;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";", mixins.mq.mSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");
const Icon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc5"
})("width:3.375rem;", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";");
const Tags = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc6"
})(Typography/* ParagraphS */.fw, ";display:flex;flex-direction:row;flex-wrap:wrap;max-width:24.5rem;margin-top:1.25rem;letter-spacing:0.013rem;text-align:left;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";");
const Footer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc7"
})(mixins/* defaultContainerSize */.sX, ";padding-top:0.5rem;padding-bottom:5rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";");
const FooterTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "ehsgszc8"
})(Typography/* Headline4 */.Ou, ";letter-spacing:0;margin-bottom:0;text-align:left;");
const FooterValues = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc9"
})("padding-top:2.5rem;display:flex;flex-direction:column;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject14())), ";");
const FooterValuesValue = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc10"
})("max-width:14.375rem;display:flex;flex-direction:row;align-items:center;&:not(:first-child){margin-top:1.5rem;}", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject15())), ";");
const FooterValuesValueImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc11"
})("width:4rem !important;height:4rem !important;");
const FooterValuesValueText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehsgszc12"
})(Typography/* ParagraphM */.Sl, ";padding-left:1rem;font-style:normal;font-weight:400;line-height:1.75rem;letter-spacing:0;text-align:left;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";");

;// CONCATENATED MODULE: ./components/sections/OurTechStack/OurTechStack.tsx







const OurTechStack = (param)=>{
    let { title , description , ourTechStackIcons , whatWeCanDoTitle , whatWeCanDoValues , titleAs  } = param;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                as: titleAs,
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionText, {
                                children: description
                            }),
                            windowSize.width <= 1200 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconsWrapper, {
                                children: ourTechStackIcons.map((param, index)=>{
                                    let { icon  } = param;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                            ...(0,imageSerializer/* imageSerializer */.l)(icon)
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tags, {
                                children: ourTechStackIcons.map((param, index)=>{
                                    let { icon  } = param;
                                    return icon.alt && "#".concat(icon.alt, " ");
                                })
                            })
                        ]
                    }),
                    windowSize.width > 1200 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconsWrapper, {
                        children: ourTechStackIcons.map((param, index)=>{
                            let { icon  } = param;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                    ...(0,imageSerializer/* imageSerializer */.l)(icon)
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Footer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
                        children: whatWeCanDoTitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterValues, {
                        children: whatWeCanDoValues.map((param, index)=>{
                            let { icon , icon_description  } = param;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterValuesValue, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterValuesValueImage, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                            ...(0,imageSerializer/* imageSerializer */.l)(icon)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterValuesValueText, {
                                        children: prismic_reactjs.RichText.asText(icon_description)
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/OurTechStack/index.ts

/* harmony default export */ var sections_OurTechStack = (OurTechStack);


/***/ })

}]);